import React, { useCallback, useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import SelectField from "../../components/Select/Select"; // optional: for city selection
import { createBanner, updateBanner, uploadFile } from "../../apis";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";

const AddEdit = ({
  fetch,
  data,
  logoutRequest,
  startLoadingRequest,
  stopLoadingRequest,
  type,
}) => {
  // Initialize form state for banner fields
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    bannerImage: data?.bannerImage || "",
    name: data?.name || "",
    description: data?.description || "",
    startDate: data?.startDate
      ? new Date(data.startDate).toISOString().slice(0, 10)
      : "",
    endDate: data?.endDate
      ? new Date(data.endDate).toISOString().slice(0, 10)
      : "",
    eventDate: data?.eventDate
      ? new Date(data.eventDate).toISOString().slice(0, 10)
      : "",
    city: data?.city || "",
    file: "",
  });

  const [errors, setErrors] = useState({
    bannerImage: "",
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    eventDate: "",
    city: "",
  });

  const openHandler = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const changeHandler = useCallback(
    (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    },
    [formData]
  );

  // If using a select field for city, you might use a similar handler:
  const selectDropdownChangeHandler = useCallback(
    (name, value) => {
      setFormData({
        ...formData,
        [name]: value,
      });
    },
    [formData]
  );

  // File upload handler for banner image. If a new file is provided, it uploads and returns the new URL.
  const fileUploadHandler = useCallback(async () => {
    console.log("formData", formData);
    if (typeof formData?.file === "object") {
      const form = new FormData();
      form.append("file", formData.file);
      const apiResponse = await uploadFile(form);
      console.log("uploadimage", apiResponse);
      return apiResponse?.data?.url;
    } else {
      return formData?.bannerImage || "";
    }
  }, [formData]);

  // Validate and submit the form
  const submitHandler = useCallback(async () => {
    try {
      startLoadingRequest();
      const uploadedBannerImage = await fileUploadHandler();
      let cleanData = {
        name: formData?.name?.trim(),
        description: formData?.description?.trim(),
        bannerImage: uploadedBannerImage,
        startDate: formData.startDate,
        endDate: formData.endDate,
        eventDate: formData.eventDate,
        city: formData.city.trim(),
      };
      let tempErrors = {};
      if (!cleanData.name) {
        tempErrors["name"] = "Name is required";
      }
      // if (!cleanData.description) {
      //   tempErrors["description"] = "Description is required";
      // }
      // if (!cleanData.bannerImage) {
      //   tempErrors["bannerImage"] = "Banner image is required";
      // }
      if (!cleanData.startDate) {
        tempErrors["startDate"] = "Start date is required";
      }
      if (!cleanData.endDate) {
        tempErrors["endDate"] = "End date is required";
      }
      if (!cleanData.eventDate) {
        tempErrors["eventDate"] = "Event date is required";
      }
      // if (!cleanData.city) {
      //   tempErrors["city"] = "City is required";
      // }
      if (Object.keys(tempErrors)?.length > 0) {
        setErrors(tempErrors);
        stopLoadingRequest();
        return;
      } else {
        setErrors({});
      }
      if (data?._id) {
        await updateBanner(data?._id, cleanData);
      } else {
        await createBanner(cleanData);
      }
      setOpen(false);
      // Reset form data after submission
      setFormData({
        bannerImage: "",
        name: "",
        description: "",
        startDate: "",
        endDate: "",
        eventDate: "",
        city: "",
        file: "",
      });
      setErrors({
        bannerImage: "",
        name: "",
        description: "",
        startDate: "",
        endDate: "",
        eventDate: "",
        city: "",
      });
      fetch();
    } catch (error) {
      stopLoadingRequest();
      toast.error(error?.response?.data?.message);
      if (error?.response?.status === 401) {
        logoutRequest();
      }
    }
  }, [
    formData,
    data,
    fileUploadHandler,
    fetch,
    logoutRequest,
    startLoadingRequest,
    stopLoadingRequest,
  ]);

  useEffect(() => {
    if (data?._id) {
      setFormData({
        bannerImage: data?.bannerImage || "",
        name: data?.name || "",
        description: data?.description || "",
        startDate: data?.startDate
          ? new Date(data.startDate).toISOString().slice(0, 10)
          : "",
        endDate: data?.endDate
          ? new Date(data.endDate).toISOString().slice(0, 10)
          : "",
        eventDate: data?.eventDate
          ? new Date(data.eventDate).toISOString().slice(0, 10)
          : "",
        city: data?.city || "",
        file: "",
      });
    } else {
      setFormData({
        bannerImage: "",
        name: "",
        description: "",
        startDate: "",
        endDate: "",
        eventDate: "",
        city: "",
        file: "",
      });
    }
  }, [data?._id, data]);

  const fileHandler = useCallback(
    (event) => {
      if (event?.target?.files[0]) {
        setFormData({
          ...formData,
          file: event.target.files[0],
          bannerImage: URL.createObjectURL(event.target.files[0]),
        });
      }
    },
    [formData]
  );

  return (
    <div className="modal-container">
      <div className="add-modal">
        <button
          className={data?._id ? "secondary" : "add"}
          onClick={openHandler}
        >
          {data?._id ? "Edit" : "Add"}
        </button>
      </div>
      <div className={open ? "modal active" : "modal"}>
        <div className="wrapper">
          <div className="header">
            <h2>{data?._id ? "Edit Banner" : "Add Banner"}</h2>
            <button type="button" className="close" onClick={openHandler}>
              <IoClose size={18} />
            </button>
          </div>
          <div className="content">
            <div className="form-section">
              <div className="input-wrapper-image">
                <div className="image">
                  {formData.bannerImage && (
                    <img src={formData.bannerImage} alt="Banner" />
                  )}
                </div>
                <label htmlFor={type}>Upload Banner Image</label>
                <input
                  onChange={fileHandler}
                  accept="image/*"
                  id={type}
                  type="file"
                />
                {errors.bannerImage && <p>{errors.bannerImage}</p>}
              </div>
              {formData.bannerImage&&<div style={{width:"100%",display:"flex",justifyContent:"center",alignItems:"center"}}>
                  <button style={{color:"red",cursor:"pointer"}} onClick={()=>setFormData({...formData,bannerImage:""})}>Remove Image</button>
              </div>}
               
              <div className="input-wrapper">
                <label>Name</label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={changeHandler}
                />
                {errors.name && <p>{errors.name}</p>}
              </div>
              <div className="input-wrapper">
                <label>Description</label>
                <input
                  name="description"
                  value={formData.description}
                  onChange={changeHandler}
                />
                {errors.description && <p>{errors.description}</p>}
              </div>
              <div className="input-wrapper">
                <label>Start Date</label>
                <input
                  name="startDate"
                  type="date"
                  value={formData.startDate}
                  onChange={changeHandler}
                />
                {errors.startDate && <p>{errors.startDate}</p>}
              </div>
              <div className="input-wrapper">
                <label>End Date</label>
                <input
                  name="endDate"
                  type="date"
                  value={formData.endDate}
                  onChange={changeHandler}
                />
                {errors.endDate && <p>{errors.endDate}</p>}
              </div>
              <div className="input-wrapper">
                <label>Event Date</label>
                <input
                  name="eventDate"
                  type="date"
                  value={formData.eventDate}
                  onChange={changeHandler}
                />
                {errors.endDate && <p>{errors.eventDate}</p>}
              </div>
              <div className="input-wrapper">
                <label>City</label>
                <input
                  name="city"
                  value={formData.city}
                  onChange={changeHandler}
                />
                {/* {errors.city && <p>{errors.city}</p>} */}
              </div>
              {/* Optionally, if using a select field for city, replace the above with your SelectField component */}
            </div>
          </div>
          <div className="footer">
            <button type="button" onClick={submitHandler} className="primary">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      startLoadingRequest: actions.loader.startLoading,
      stopLoadingRequest: actions.loader.stopLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AddEdit);
